import script from "./RemoveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveModal.vue?vue&type=script&setup=true&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=3260483f&lang=scss&scoped=true"
script.__scopeId = "data-v-3260483f"

export default script